<template>
  <div id="app">
    <transition name="crossfade">
      <router-view :key="$route.fullPath" />
    </transition>
  </div>
</template>

<script>
export default {};
</script>

<style>
html {
  scroll-behavior: smooth;
}

body {
  --dark-bg: #192026;
  --mid-grey: #3a4959;
  --gold: #ffcc66;
  --red: #a63232;
  --light-blue: #d8e0e8;
  --txtclr: var(--light-blue);
  --strongtxt: white;
  --navbg: white;
  --navtxt: black;

  margin: 0px;
  background: black;
  box-sizing: border-box;
  color: white;
  font-family: futura-pt, sans-serif;
  /* position: absolute; */
}
h1 {
  font-size: 7.5vh;
  font-weight: 500;
  color: var(--gold);
  margin-block-start: 0px;
  margin-block-end: 0px;
}
p {
  text-align: left;
  font-size: 2.75vh;
  font-weight: 300;
  font-style: normal;
  color: var(--light-blue);
  letter-spacing: 0.1vh;
  margin-block-start: 1vh;
  margin-block-end: 1vh;
  max-width: 100vh;
}
strong {
  font-weight: 500;
  color: var(--strongtxt);
}

*::-webkit-scrollbar {
  width: 1vmin;
  height: 0vmin;
  background-color: black;
}

/* *::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
} */

*::-webkit-scrollbar-thumb {
  background-color: slategray;
  outline: 1vmin solid black;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  height: 100%;
  width: 100%;
  /* overflow: auto; */
  /* scroll-snap-type: y proximity; */

  overflow-x: hidden;
}

.crossfade-enter-active,
.crossfade-leave-active {
  transition: opacity 0.6s;
}
.crossfade-enter,
.crossfade-leave-to {
  opacity: 0;
}
</style>
